import { connect } from 'react-redux';

import UpgradePath from './components/UpgradePath';

export default connect((state) => ({
  shouldShowUpgradeButton:
    state.organizations.selected?.shouldShowUpgradeButton,
}))(UpgradePath);
